import SecureLS from 'secure-ls';

// LOCAL-STORAGE

const getItem = (item) => {
    if(localStorage)
        return localStorage.getItem(item);
    return null;
}

const setItem = (item,value) => {
    if(localStorage)
        return localStorage.setItem(item, value);

    return null;
}

const removeItem = (item) => {
    if(localStorage)
        return localStorage.removeItem(item);

    return null;
}

const removeAll = () => {
    if(localStorage)
        return localStorage.clear();

    return null;
}

// SECURE-LS
const getSecureItem = (item) => {
    var secureData = new SecureLS();
    return secureData.get(item);
}

const getSecureAllItem = () => {
    var secureData = new SecureLS();
    return secureData.getAllKeys();
}

const setSecureItem = (item, value) => {
    var secureData = new SecureLS();
    return secureData.set(item, value);
}

const removeSecureItem = (item) => {
    var secureData = new SecureLS();
    return secureData.remove(item);
}

const removeSecureAll = () => {
    var secureData = new SecureLS();
    return secureData.removeAll();
}

const updateValidationStorage = (item) => {
    const userData = StorageService.getSecureItem('userData');
    let reported = StorageService.getSecureItem('reported_feature');
    reported = reported ? reported : {};

    if(userData && (!reported[userData.email] || !reported[userData.email][item])){
        if(!reported[userData.email]){
            reported[userData.email] = {
                [item]: true 
            };
        }else{
            reported[userData.email][item] = true;
        }
        StorageService.setSecureItem('reported_feature',reported);
    }
}
const getValidationStorage = (item) => {
    const userData = StorageService.getSecureItem('userData');
    let reported = StorageService.getSecureItem('reported_feature');
    reported = reported ? reported : {};
    return userData && reported[userData.email] && reported[userData.email][item]
}

const StorageService = {
    getItem,
    setItem,
    removeItem,
    removeAll,
    getSecureItem,
    getSecureAllItem,
    setSecureItem,
    removeSecureItem,
    removeSecureAll,
    updateValidationStorage,
    getValidationStorage
}

export default StorageService;
